import { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export interface linkButtons {
    title: string;
    searchTerms: string;
}

interface LinkButtonsProps {
    linkButtons: linkButtons[];
}

const LinkButtons: FunctionComponent<LinkButtonsProps> = ({ linkButtons }) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {linkButtons.map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        width: '46%',
                        margin: '0.3rem',
                        cursor: 'pointer',
                    }}
                >
                    <Typography
                        onClick={() => navigate(item.searchTerms)}
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            color: '#B75332',
                        }}
                    >
                        •{' '}
                        <Box
                            component="span"
                            sx={{
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            {item.title}
                        </Box>
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default LinkButtons;
